import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { CustomerPaymentMethodFormSchemaValues } from 'src/features/paymentMethods/utils/formSchema';
import { CustomerPaymentMethod } from 'src/features/paymentMethods/utils/types';

const RESOURCE = '/customers/customer-payment-method/';

type MutationFnType = typeof mutationFn;

const mutationFn = ({ ...data }: CustomerPaymentMethodFormSchemaValues): Promise<CustomerPaymentMethod> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateCustomerPaymentMethod };
